export const orderTyreDetail = {
  amount: 699.65,
  arrival_time: null,
  can_convert_to_411: false,
  canceled_at: null,
  city: '\u4e0a\u6d77\u5e02',
  claims_pending: false,
  claims_record: {
    can_claim: true,
    id: 4,
    status: 2,
    status_label: '\u5df2\u6279\u51c6'
  },
  confirmed_at: null,
  coupon_amount: 0,
  coupons: [],
  created_at: '2021-02-03 06:30:39',
  customer: '\u8096\u53ee\u5f53',
  dealer: {
    address: '\u4e0a\u6d77\u5e02\u95f5\u884c\u533a\u83b2\u82b1\u5357\u8def2338\u53f73\u5e62',
    city_id: 1,
    earliest: '11:00',
    express_end_time: '15:25',
    express_start_time: '09:00',
    id: 12,
    name: '\u4e0a\u6d77\u8d8a\u661f\u6c7d\u8f66\u6709\u9650\u516c\u53f8',
    tel: '136162681291'
  },
  dealer_done_at: null,
  deposit_amount: 0,
  err_msg: null,
  finished: false,
  finished_at: null,
  id: 121437,
  is_insurance_claim: true,
  logistics_quantity: 1,
  may_be_411: true,
  mobile: '15228593532',
  onsite_confirm_url: null,
  order_no: 'YE202102030001',
  paid_at: null,
  payment_method: '\u5230\u5e97\u652f\u4ed8',
  plate_number: '\u4eacA12345',
  province: '\u4e0a\u6d77\u5e02',
  quantity: 1,
  rate: {
    comment: '',
    rates: []
  },
  reason: null,
  reason_value: null,
  refund_approved_at: null,
  refund_reason: null,
  refund_requested_at: null,
  refunded_at: null,
  sa_user: {
    mobile: '13911435450',
    name: 'panjing'
  },
  scheduled_at: null,
  status: '\u5907\u8d27\u4e2d',
  status_code: 11,
  stock_up_timed_out: false,
  timed_out: null,
  type: 2,
  type_label: '\u5230\u5e97\u8ba2\u8d2d',
  tyre: {
    brand: {
      code: 'Hankook',
      name: '\u97e9\u6cf0'
    },
    msrp: 699.65, //手动
    has_commodity: true, //手动
    dealer_stock: 0,
    eclp_stock: 3,
    left_quota: null,
    mbpn: 'MQALCN89992163',
    name: 'A 180 / A 180 L / A 200 / A 200 4MATIC / A 200 L / A 220 4MATIC / B 180 / B 200 / B 250 4MATIC / C 260 L / CLA 200 / CLA 250 \u539f\u914d MO',
    next_day_stock: 3,
    quantity: 1,
    short_name: 'A 200 L \u539f\u914d MO',
    spec: '205/55R17',
    subname: '205/55 R17 91W \u97e9\u6cf0 Ventus S1 evo\u00b2',
    two_hours_stock: 1
  },
  tyre_images: [
    {
      created_at: '2021-02-03 06:30:30',
      id: 6906,
      order_id: 121437,
      position: 2,
      position_label: '\u53f3\u524d\u8f6e',
      thumbnail: null,
      url: null,
      wx_server_id: '1237378768e7q8e7r8qwesafdasdfasdfaxss111'
    }
  ],
  users_id: 123911,
  vehicle_name: 'A 200 L',
  wip_no: null
}
